import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProgressBar from 'components/ProgressBar';
import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import { useMutation } from '@apollo/client';
import {
  SUBSCRIBE_BOOKING_ADD_ONS
} from 'graphql/service';
import { Head, Container, Content, Footer } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const EarlyCheckIn = ({earlyCheckInBookings, status}) => {

  const navigate = useNavigate()
  const groupId = useParams().groupId
  const [earlyCheckInFee, setEarlyCheckInFee] = useState(true)
  const [addOns, setAddOns] = useState([])

  const [subscribeBookingAddOns, { loading }] = useMutation(SUBSCRIBE_BOOKING_ADD_ONS,
    {
      onCompleted: (data) => {
        navigate(`/group-check-in/confirm-identity/${groupId}`);
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )
  
  useEffect(() => {
    if(earlyCheckInBookings.length === 0) {
      navigate(`/group-check-in/confirm-identity/${groupId}`);
    }
    const originalAddOns = earlyCheckInBookings?.map((booking) => {
      return {
        bookingId: booking.bookingId,
        id: "4c773a2c-0d0a-44ba-8680-d34244fea4d5", //early check in addon id
        quantity: booking.addons?.find(addon => addon.bookingAddOn.bookingAddOnId === "4c773a2c-0d0a-44ba-8680-d34244fea4d5")?.quantity || 0
      }
    })
    setAddOns(originalAddOns)
  }, [earlyCheckInBookings, navigate, groupId])

  const checkBoxArray = earlyCheckInBookings?.map((booking, index) => {
    return (
      <Checkbox
        key={booking.bookingId}
        checked={addOns?.[index]?.quantity > 0}
        onChange={() => {
          const newAddOns = [...addOns]
          newAddOns[index].quantity = newAddOns[index].quantity > 0 ? 0 : 1
          setAddOns(newAddOns)
        }}
        title={`Room: ${index+1} ${booking.fullName}`}
      />
    )
  })
    
  const handleContinue = () => {
    if(loading) return
    subscribeBookingAddOns({
      variables: {
        input: {
          addOns: addOns
        }
      }
    })
  }

  return (
    <Container>
      <ProgressBar step={1} groupId={groupId} status={status}/>
      <Content>
        <Head>Early Checkin</Head>
        <div className='text'>
          <div>This customer does not check in until 3:00PM.</div>
          <div>Which rooms would you like to check {earlyCheckInBookings?.length>1? 'them': earlyCheckInBookings?.[0]?.fullName} in early?</div>
        </div>
        {earlyCheckInBookings?.length > 1? (
          <div className='list'>
            {checkBoxArray}
          </div>
        ): null}
      </Content>
      <Footer>
        <Checkbox
          checked={!earlyCheckInFee}
          onChange={(e) => setEarlyCheckInFee(!earlyCheckInFee)}
          title="Do not apply early check in fee"
        />
        <Button
          mainPage
          success
          onClick={handleContinue}
          data-loading={loading}
          additionalstyle={`
            width: 104px;
          `}
        >
          {loading? null: 'Continue'}
        </Button>
      </Footer>
    </Container>
  );
}

export default EarlyCheckIn;